
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxFilterRow,
    DxSearchPanel,
    DxScrolling,
    DxPager,

} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxToast } from 'devextreme-vue/toast';
import 'devextreme-vue/text-area';


import ServicioListadoInformacionService from '../services/serviciolistadoinformacion-service';
import ListadoInformacionService from '../services/listadoinformacion-service';



export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxEditing,
        DxLookup,
        DxForm,
        DxItem,
        DxFilterRow,
        DxSearchPanel,
        DxScrolling,
        DxPager,
        DxToast,

    },
    props: {
        supplierId: {
            type: Number,
            default: null,
        },
    },
    data() {

        return {

            procedimientos: null,
            dataSourceGrupo: null,
            dataSourceSolicitudServicio: null,
            allowedPageSizes: [5, 10, 20, 50, 'all'],
            showInfo: true,
            showNavButtons: true,
            isVisible: false,
            message: '',
            type: 'info',
            popupOptions: {
                title: 'Listado de Informacion',
                showTitle: true,
                width: 850,
                height: 220,
            }


        };
    },
    created() {

        this.serviciolistadoinformacionService = new ServicioListadoInformacionService();
        this.listadoinformacionService = new ListadoInformacionService();

    },
    mounted() {

        this.loadDataInfo();
    },
    methods: {
        loadDataInfo() {
            let id = this.supplierId;
            let myJSON = JSON.stringify({
                pid: id
            });


            this.serviciolistadoinformacionService.getServicioListadoInformacion(myJSON).then(data => this.dataSourceSolicitudServicio = data);
            this.listadoinformacionService.getListadoInformacion().then(data => this.dataSourceGrupo = data);
        },

        deleteRegister(e) {

            let myJSON = JSON.stringify({
                pid: e.data.id,
            });


            this.serviciolistadoinformacionService.deleteServicioListadoInformacion(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha eliminado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        createRegister(e) {


            let id = this.supplierId;

            let myJSON = JSON.stringify({
                plistadoinformacionid: e.data.listadoinformacionid,
                pservicioid: id,
            });



            this.serviciolistadoinformacionService.createServicioListadoInformacion(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha creado el registro';
                    this.isVisible = true;

                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }
                this.loadDataInfo();

            });


        },
        onSaved() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        onEditCanceled() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        logEvent(eventName) {
            this.events.unshift(eventName);
        }
        ,
    },
};
